module.exports = __webpack_public_path__ + "9220b22f270504d0081c08a5e62abf5c.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/happiness-bg.png
 ** module id = 1549
 ** module chunks = 0
 **/